export enum PaymentActions {
  UPDATE_RESPONSE = 'UPDATE_RESPONSE',
  UPDATE_ERROR = 'UPDATE_ERROR',
  UPDATE_LOADING_STATUS = 'UPDATE_LOADING_STATUS',
  UPDATE_PAYMENT = 'UPDATE_PAYMENT',
  RESET_PAYMENT = 'RESET_PAYMENT',
}
